<script setup>
import { ref, watch } from 'vue';
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Filler,
} from 'chart.js';

const props = defineProps({
  timeseries: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
});

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Filler
);

const canvasRef = ref(null);
let chartInstance = null;

watch(
  [() => props.timeseries, canvasRef],
  () => {
    if (!canvasRef.value || !props.timeseries.length) return;
    if (chartInstance) chartInstance.destroy();
    chartInstance = new Chart(canvasRef.value, {
      type: 'line',
      data: {
        labels: props.timeseries.map(p => p.date),
        datasets: [
          {
            label: 'Receita',
            data: props.timeseries.map(p => p.revenue),
            borderColor: '#3B82F6',
            backgroundColor: 'rgba(59,130,246,0.08)',
            fill: true,
            tension: 0.3,
            pointRadius: 3,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false },
          tooltip: { mode: 'index', intersect: false },
        },
        scales: {
          y: { beginAtZero: true, ticks: { callback: v => `R$ ${v}` } },
          x: { grid: { display: false } },
        },
      },
    });
  },
  { immediate: false }
);
</script>

<template>
  <div>
    <div
      v-if="isLoading"
      class="flex items-center justify-center py-8 text-slate-500"
    >
      <span class="i-lucide-loader-circle animate-spin mr-2" />
    </div>
    <div
      v-else-if="!timeseries.length"
      class="flex items-center justify-center py-8 text-slate-400 text-sm"
    >
      {{ $t('PDV_SALES_REPORT.NO_DATA') }}
    </div>
    <canvas v-else ref="canvasRef" class="max-h-64" />
  </div>
</template>
